import React, { Component } from "react";
import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Spinner, Card, Form } from "react-bootstrap";
import logo from "../assets/images/logo.png";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import axios from "axios";

let baseUrl = process.env.REACT_APP_BASE_URL;

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      identifier: "", // Can be email or phone
      password: "",
      showPassword: false,
      loading: false,
      disabled: false,
    };

    this.togglePassword = this.togglePassword.bind(this);
  }

  togglePassword = (e) => {
    this.setState({ showPassword: e.target.checked });
  };

  isEmail = (value) => {
    // Simple email detection
    return value && value.includes("@") && value.includes(".");
  };

  login = async () => {
    const { password, identifier } = this.state;
    const self = this;

    if (!identifier || identifier.trim().length === 0) {
      Swal.fire({
        title: "Required",
        text: "Please enter your email address or phone number",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    if (!password || password.length === 0) {
      Swal.fire({
        title: "Required",
        text: "Please enter your password",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    this.setState({ loading: true, disabled: true });

    // Determine if identifier is email or phone
    const trimmedIdentifier = identifier.trim();
    const isEmailLogin = this.isEmail(trimmedIdentifier);

    const payload = {
      countryid: "+234",
      password: password,
      // Send as telephone for backwards compatibility - backend will detect if it's an email
      telephone: trimmedIdentifier,
    };

    // If it's clearly an email, also set the email field
    if (isEmailLogin) {
      payload.email = trimmedIdentifier.toLowerCase();
    }

    try {
      const response = await axios.post(`${baseUrl}/Users/login`, payload);
      const { status, data } = response;

      if (status === 200) {
        this.setState({ loading: false });
        localStorage.setItem("userid", data.userid);
        localStorage.setItem("email", data.email);
        localStorage.setItem("token", data.token);
        self.props.history.push("/dashboard");
      }
    } catch (error) {
      this.setState({ loading: false, disabled: false });

      if (error?.response?.status === 409) {
        sessionStorage.setItem(
          "registration:ongoing",
          JSON.stringify(error?.response?.data)
        );
        sessionStorage.setItem(
          "registration:userId",
          JSON.stringify(error?.response?.data.userId)
        );

        const message =
          "Your registration is still in progress. You will be redirected to complete your registration.";
        Swal.fire({
          html: message,
          icon: "info",
          timerProgressBar: false,
          showConfirmButton: true,
          showCancelButton: false,
          showCloseButton: false,
          cancelButtonColor: "#ff7b7b",
          confirmButtonText: "Complete Registration",
          allowOutsideClick: false,
        }).then(() => {
          self.props.history.push("/register-food-scientist-v3");
        });
      } else if (error?.response?.status === 400) {
        Swal.fire({
          html: error?.response?.data?.message || "Login failed. Please check your credentials.",
          icon: "error",
          timerProgressBar: true,
          showConfirmButton: false,
          showCancelButton: true,
          showCloseButton: true,
          cancelButtonColor: "#ff7b7b",
        });
      } else {
        Swal.fire({
          html:
            error?.response?.data?.message ||
            "Encountered an error while attempting to login.",
          icon: "error",
          timerProgressBar: true,
          showConfirmButton: false,
          showCancelButton: true,
          showCloseButton: true,
          cancelButtonColor: "#ff7b7b",
        });
      }
    }
  };

  handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.login();
    }
  };

  render() {
    const { loading, disabled, showPassword } = this.state;
    return (
      <div className="loginContainer">
        <span style={{ display: "none" }}>v0.0.2</span>
        <div
          className="d-flex justify-content-center"
          style={{
            width: "100%",
            top: 0,
            bottom: 0,
          }}
        >
          <Card
            style={{ backgroundColor: "rgba(255,255,255,0.7)" }}
            className="d-flex justify-content-center cardContainer loginContainer-content"
          >
            <img
              src={logo}
              alt=""
              style={{
                width: "15%",
                position: "absolute",
                top: 18,
                alignSelf: "center",
              }}
            />

            <h5
              className="nicfostText"
              style={{
                position: "relative",
                fontWeight: "bold",
                top: 25,
                color: "#333",
                textAlign: "center",
              }}
            >
              NIGERIAN COUNCIL OF FOOD SCIENCE AND TECHNOLOGY
              <br />
              (NiCFoST)
            </h5>
            <div className="mb-3"></div>
            <h6
              style={{
                textAlign: "center",
                marginTop: 10,
                color: "red",
                fontSize: 12,
              }}
            >
              NB: Sign in if you already have an account. This applies if you
              have completed or have an ongoing registration.
            </h6>

            <div className="container" style={{ marginTop: 20 }}>
              <Form>
                <h6 className="nicfostText">Sign in to continue</h6>

                <Form.Floating className="mb-3">
                  <input
                    className="form-control shadow-none"
                    type="text"
                    placeholder="Email or Phone Number"
                    onChange={(e) =>
                      this.setState({ identifier: e.target.value })
                    }
                    onKeyPress={this.handleKeyPress}
                  />
                  <label>Email or Phone Number</label>
                </Form.Floating>
                <Form.Floating>
                  <input
                    className="form-control shadow-none"
                    type={showPassword ? "text" : "password"}
                    id="password"
                    placeholder="Password"
                    onChange={(e) =>
                      this.setState({ password: e.target.value })
                    }
                    onKeyPress={this.handleKeyPress}
                  />
                  <label>Password</label>
                </Form.Floating>
                <br />
                <Form.Floating>
                  <input
                    className="shadow-none"
                    type="checkbox"
                    onChange={this.togglePassword}
                  />
                  <span>
                    {showPassword ? "Hide password" : "Show password"}
                  </span>
                </Form.Floating>

                <Link to="/password-reset" style={{ textDecoration: "none" }}>
                  <h6
                    style={{
                      textAlign: "right",
                      textTransform: "capitalize",
                      marginTop: 10,
                      color: "red",
                      fontSize: 13,
                    }}
                  >
                    Forgot password?
                  </h6>
                </Link>

                <div className="d-grid gap-2 mb-3" style={{ marginTop: 30 }}>
                  <button
                    style={{ backgroundColor: "#003314" }}
                    className="btn btn-success btn-lg"
                    onClick={(e) => {
                      e.preventDefault();
                      this.login();
                    }}
                    disabled={disabled}
                    type="button"
                  >
                    {loading ? (
                      <Spinner animation="border" variant="light" size="sm" />
                    ) : (
                      "Login"
                    )}
                  </button>
                </div>
              </Form>

              <div style={{ position: "relative", top: 5 }}>
                <h5 className="text-center text-dark mobile-text">
                  Don't have an account?{" "}
                  <Link
                    to="/register"
                    style={{ textDecoration: "underline", color: "green" }}
                  >
                    sign up
                  </Link>
                </h5>
              </div>

              <div style={{ marginTop: 15, textAlign: "center" }}>
                <h6 className="text-muted mobile-text">
                  Are you a company?{" "}
                  <a
                    href={process.env.REACT_APP_COMPANY_PORTAL_URL || "https://portal.nicfost.gov.ng/company"}
                    style={{ textDecoration: "underline", color: "green" }}
                  >
                    Sign in to Company Portal
                  </a>
                </h6>
              </div>
            </div>
          </Card>
        </div>
      </div>
    );
  }
}

export default Login;
